/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ResponsiveComponent } from '../../../utils/functions';
import TableColumnSearch from '../../../components/Input/TableColumnSearch';
import Sidebar from '../../../components/Sidebar';
import { CustomTable } from '../../../components/Table';
import { plusicon, refreshicon } from '../../../components/imagepath';
import Header from '../../../components/Header';
import { ActionGetShiftsList } from '../../../store/Actions/StaffAction';
import { ActionDeleteById } from '../../../store/Actions/CommonAction';
import { matchPermissions } from '../../../utils/Permission';
import { PERMISSIONS } from '../../../constants';
const { confirm } = Modal;

const Shifts = () => {
  const { loader, exercise } = useSelector(state => state?.MasterData);
  const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const { therapistShift } = useSelector(state => state?.Staff);
  const pageSize = 10;
  const dispatch = useDispatch();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const Size = ResponsiveComponent();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { userDetails } = useSelector(state => state?.auth);
  const [SearchList, setSearchList] = useState([]);
  const mergedArrow = useMemo(() => {
    if (arrowAtCenter)
      return {
        pointAtCenter: true,
      };
    return showArrow;
  }, [showArrow, arrowAtCenter]);
  const handleSearch = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys?.[0]);
    setSearchedColumn(dataIndex);

    if (params[dataIndex]) {
      window.location.replace(`/exercise?page=1&filterlist=true&${dataIndex}=${selectedKeys?.[0]}`);
    } else {
      window.location.replace(`/exercise?${location.search}&${dataIndex}=${selectedKeys?.[0]}`);
    }
  };
  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
    window.location.replace(`?page=1`);
  };

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.SHIFTS.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.SHIFTS.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.SHIFTS.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.SHIFTS.CREATE);
  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?.id)}>
          Edit
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );
  const column = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      // key: "Sr",
      render: (text, record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'title',
      dataIndex: 'title',
      ...TableColumnSearch({
        dataIndex: 'orderIndex',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
      }),
    },
    {
      title: 'Time',
      dataIndex: 'title',
      render: (text, record) => {
        const startTime = new Date(record?.startTime);
        const endTime = new Date(record?.endTime);

        const formattedEndTime = endTime?.toLocaleTimeString('en-US', {
          hour12: true, // Use 24-hour format
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        const formattedStartTime = startTime?.toLocaleTimeString('en-US', {
          hour12: true, // Use 24-hour format
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });

        return (
          <span>
            {formattedStartTime} -- TO -- {formattedEndTime}
          </span>
        );
      },
      ...TableColumnSearch({
        dataIndex: 'title',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
        filtered: params?.title,
      }),
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: !canUpdate && !canDelete ? null : 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text, record, num) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover
              placement="left"
              title={record.title}
              content={() => content(record)}
              arrow={mergedArrow}
            >
              <Button type="dashed">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];
  useEffect(() => {
    dispatch(ActionGetShiftsList({ Query: `` }));
    setRefresh(false);
  }, [dispatch, params?.page, Refresh]);

  const handleSearch1 = searchTerm => {
    var newp = params;
    newp.page = searchTerm;
    window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
  };

  const EditList = searchTerm => {
    window.location.href = `/shifts/add-shifts?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.title}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteById({ Query: `admin/therapistShift/${item?.id}` }, Res => {
            if (Res?.statusCode === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/shifts">shifts</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">shifts List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>shifts List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCerate && (
                                    <Link
                                      to="/shifts/add-shifts"
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}

                                  <Link
                                    onClick={() => window.location.reload()}
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}
                      {canView ? (
                        <CustomTable
                          CurrentPageNum={parseInt(params?.page) || 1}
                          OnChange={v => {
                            handleSearch1(v);
                          }}
                          TotalPageList={exercise?.totalDocs}
                          column={column}
                          dataSource={therapistShift}
                          dataSourceLength={exercise?.docs?.length}
                          pageSize={10}
                          loader={loader}
                          ShowHeader={true}
                          Header={<div className="staff-search-table"></div>}
                          key={'hi'}
                        />
                      ) : (
                        <div className="permission-denied-message">
                          You do not have permission to view the shifts list.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Shifts;
